"use client";

import { useEffect, useLayoutEffect } from "react";

import { scheduleAfterLoad } from "@/lib/observability/after-load";
import {
  type AppName,
  initAppRUM,
  setAppRUMTrackingDisabled,
} from "@/lib/observability/rum";

/** Runs `start` later; answers a cancel. */
export type RumSchedule = (start: () => void) => () => void;

export interface AppRUMProps {
  app: AppName;
  disabled?: boolean;
  isPrivateUrl?: (url: string) => boolean;
  /** When RUM starts. Pass a module-level function: it is an effect dep. */
  schedule?: RumSchedule;
}

const LOAD_DELAY_MS = 5000;

const afterLoadDelay: RumSchedule = (start) =>
  scheduleAfterLoad(start, LOAD_DELAY_MS);

export function AppRUM(props: AppRUMProps) {
  const {
    app,
    disabled = false,
    isPrivateUrl,
    schedule = afterLoadDelay,
  } = props;
  useLayoutEffect(() => {
    setAppRUMTrackingDisabled(disabled);
  }, [disabled]);
  useEffect(() => {
    if (disabled) {
      return;
    }
    return schedule(() => void initAppRUM({ app, isPrivateUrl }));
  }, [app, disabled, isPrivateUrl, schedule]);
  return null;
}
